export default {
    methods: {
        setPostType() {
            if (document.body.classList.contains('page-template-page-catalog')) {
                return 'catalogus';
            } else if (document.body.classList.contains('page-template-page-projects')) {
                return 'projecten';
            }
        }
    }
}
